export const LOCALES = {
  'en-US': 'English (United States)',
  'en-GB': 'English (United Kingdom)',
  'en-PL': 'English (Pseudolocalized/Debug)',
} as const;

export const SUPPORTED_LOCALES = Object.keys(LOCALES) as Array<
  keyof typeof LOCALES
>;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE = 'en-US';
export const PSEUDO_LOCALE = 'en-PL';
